import { useHomePageStore } from "@/store";
import { getAuthenticatedUser, useAuthStore } from "@/store/auth.store";
import { formatNumberWithCommas } from "@/utils";
import { pointsToYen } from "@/utils/pointsToYen";
import { ThumbaTrophyIcon } from "@roman/shared/components/Icons";
import { AvatarIcon } from "@roman/shared/components/Icons/AvatarIcon";
import LoadingSpinner from "@roman/shared/components/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import { PlusIcon } from "../Icons/plus-icon";
import { Button } from "../ui/button";
import { AccountInfo } from "./AccountInfo";
import { Icon } from "./Icon";
import { Invitation } from "./Invitation";
import { NewUserInfo } from "./NewUserInfo";
import { PointIcon } from "./PointIcon";
import { SNSIcons } from "./SNSIcons";

export const MyPage = () => {
  const setIsOpenMyPageSidebar = useHomePageStore((state) => state.setIsOpenMyPageSidebar);
  const navigate = useNavigate();
  const { authState, logout } = useAuthStore();
  const user = getAuthenticatedUser();

  const handleNavigateToWithdrawal = () => {
    window.location.href = "/withdrawal";
  };

  return (
    <div className="z-20 right-0 top-0 w-full overflow-y-scroll bg-white p-5">
      {/* Header */}
      <div className="h-10 flex items-center justify-between mb-5">
        <h3 className="text-xl font-semibold -tracking-[.01em] text-black">マイページ</h3>
        <button
          type="button"
          className="h-10 w-10 rounded-full bg-transparent"
          onClick={() => setIsOpenMyPageSidebar(false)}
        >
          <img src="/assets/close.svg" alt="close button" className="w-full h-full rounded-full bg-transparent" />
        </button>
      </div>

      {/* profile */}
      <div className="h-[50px] flex items-center gap-[21px] mb-5">
        <div className="flex justify-center items-center rounded-full h-[50px] w-[50px] bg-secondary cursor-pointer">
          {user?.photoUrl ? (
            <img
              src={user.photoUrl}
              alt={user.name.substring(0, 1)}
              className=" rounded-full"
              referrerPolicy="no-referrer"
            />
          ) : (
            <AvatarIcon className=" text-secondary" />
          )}
        </div>
        <div className="flex flex-col items-start gap-2.5">
          <h3 className="text-xl font-semibold text-black">{user.name}</h3>

          <Button
            variant="link"
            className="font-medium"
            onClick={() => {
              setIsOpenMyPageSidebar(false);
              navigate("/profile/edit");
            }}
          >
            プロフィールを編集する
          </Button>
        </div>
      </div>

      {/* point */}
      <div className="flex flex-col gap-2 pb-[39px] items-start border-b border-gray-200 border-solid">
        <h3 className="text-lg font-semibold -tracking-[.01em]">保有ポイント</h3>
        {/* Free */}
        <div className="flex flex-col items-start gap-6 w-full">
          <div className="flex flex-col items-start gap-2 w-full">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-[7px]">
                <PointIcon className="w-[24px] h-[24px]" />
                <p className="text-base text-dark-gray font-semibold -tracking-[.01em]">無料ポイント</p>
              </div>

              <div className="flex items-center gap-2.5 ">
                <p className="text-base font-semibold text-black -tracking-[.01em]">
                  {formatNumberWithCommas(user.freePoints)}
                </p>
                <button
                  className="h-[26px] w-[26px] rounded-full"
                  type="button"
                  onClick={() => {
                    setIsOpenMyPageSidebar(false);
                    navigate("/redeem-points");
                  }}
                >
                  <PlusIcon className="w-full h-full text-green" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Paid */}
        <div className="flex flex-col items-start gap-6 w-full">
          <div className="flex flex-col items-start gap-2 w-full">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-[7px]">
                <ThumbaTrophyIcon className="w-[24px] h-[24px]" />
                <div className="flex flex-col items-center justify-center">
                  <p className="text-base font-semibold text-dark-gray -tracking-[.01em]">所持賞金</p>
                </div>
              </div>

              <div className="flex items-center gap-2.5 ">
                <p className="text-base font-semibold text-black -tracking-[.01em]">
                  {pointsToYen(user.redeemablePoints)}円
                </p>
                <button className="h-[26px] w-[26px] rounded-full" type="button" onClick={handleNavigateToWithdrawal}>
                  <img src="/assets/add-paid-points.svg" alt="add points for free" className="w-full h-full" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Invitation code */}
      <Invitation />

      <NewUserInfo setIsOpenMyPageSidebar={setIsOpenMyPageSidebar} />

      {/* Account Info */}
      <AccountInfo />

      {/* SNS Icons */}
      <SNSIcons />
      <div className="flex items-center justify-center pt-[39px] pb-[19px]">
        <Button
          className="w-2/3 rounded-full border-primary text-primary hover:text-white hover:bg-primary/90"
          variant="outline"
          onClick={logout}
        >
          {authState === "loggingOut" ? <LoadingSpinner size="sm" /> : <span>ログアウト</span>}
        </Button>
      </div>

      <div className="flex items-center justify-center w-full mb-[40px]">
        <Icon src="/assets/mypage-icon.svg" imageSize={{ width: "183", height: "63.75" }} />
      </div>
    </div>
  );
};
